import { render, staticRenderFns } from "./NotificationAppointmentReminder.vue?vue&type=template&id=ab45fcfe&scoped=true&"
import script from "./NotificationAppointmentReminder.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentReminder.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAppointmentReminder.vue?vue&type=style&index=0&id=ab45fcfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab45fcfe",
  null
  
)

export default component.exports